var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox"},[_c('input',{attrs:{"type":"file","id":"choose","accept":"image/*","multiple":_vm.multiple},on:{"change":_vm.change}})])
}
var staticRenderFns = []

export { render, staticRenderFns }